import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import "./avatar.styl";
const template = require("./avatar.vue");

@Component({
  template: template
})
export default class AvatarComponent extends Vue {

  @Prop()
  avatar: string;
  @Prop({ default: "sm" })
  size: string;

  style: {};

  created(): void {
    this.style = { "background-image": "url(" + this.getAvatar + ")" };
  }

  get getAvatar(): string {
    return this.avatar || "/assets/icons/logo.svg";
  }

}

Vue.component("cmAvatar", AvatarComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/avatar/avatar.ts